const INITIAL_STATE = {
  error: null,
  loading: null,
  data: [],
};

const HistoryEmails = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "HISTORY_EMAILS_GET_REQUEST":
      return { loading: true, error: false, data: [] };
    case "HISTORY_EMAILS_GET_ERROR":
      return { loading: false, error: true, data: [] };
    case "HISTORY_EMAILS_GET_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "HISTORY_EMAILS_GET_RESET":
      return { loading: false, error: false, data: [] };  
    default:
      return state;
  }
};

export default HistoryEmails;
